// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recover_container{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
    background-color: #ECEFFF;
    text-align: center;
    box-sizing: border-box;
}

.recover_content {
    background-color: #354ab2;
    padding: 30px;
    color: white;
    width: 100%;
    max-width: 85%;
    height: 70vh;
    font-family: 'Inter', sans-serif;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 24px;
}


h1 {
    font-size: 5rem;
    margin-bottom: 15px;
    letter-spacing: 0.6px;
}
span{
    color: #0bccd2
}

p {
    font-size: 18px;
    margin-bottom: 20px;
    letter-spacing: 0.5px;
}

.download_btn {
    background-color: #00c4cc;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.download {
    display: flex;
    text-align: center;
    justify-content: center;
    gap: 38px;
}

.download_btn:hover {
    background-color: #00a3a8;
}

/* Media Queries */
@media (max-width: 768px) {
    .recover_content {
        padding: 20px;
    }

    h1 {
        font-size: 2rem;
    }

    p {
        font-size: 12px;
        margin-bottom: 15px;
    }

    .download_btn {
        padding: 8px 16px;
        font-size: 0.9rem;
    }
}

@media (max-width: 480px) {
    .recover_content {
        padding: 15px;
    }

    h1 {
        font-size: 1.5rem;
    }

    p {
        font-size: 10px;
        margin-bottom: 10px;
    }

    .download_btn {
        padding: 6px 12px;
        font-size: 0.8rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Recovery/Recoverysoftware.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,WAAW;IACX,cAAc;IACd,YAAY;IACZ,gCAAgC;IAChC,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;AACvB;;;AAGA;IACI,eAAe;IACf,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;AACJ","sourcesContent":[".recover_container{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100vh;\n    background-color: #ECEFFF;\n    text-align: center;\n    box-sizing: border-box;\n}\n\n.recover_content {\n    background-color: #354ab2;\n    padding: 30px;\n    color: white;\n    width: 100%;\n    max-width: 85%;\n    height: 70vh;\n    font-family: 'Inter', sans-serif;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    border-radius: 24px;\n}\n\n\nh1 {\n    font-size: 5rem;\n    margin-bottom: 15px;\n    letter-spacing: 0.6px;\n}\nspan{\n    color: #0bccd2\n}\n\np {\n    font-size: 18px;\n    margin-bottom: 20px;\n    letter-spacing: 0.5px;\n}\n\n.download_btn {\n    background-color: #00c4cc;\n    color: white;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.download {\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    gap: 38px;\n}\n\n.download_btn:hover {\n    background-color: #00a3a8;\n}\n\n/* Media Queries */\n@media (max-width: 768px) {\n    .recover_content {\n        padding: 20px;\n    }\n\n    h1 {\n        font-size: 2rem;\n    }\n\n    p {\n        font-size: 12px;\n        margin-bottom: 15px;\n    }\n\n    .download_btn {\n        padding: 8px 16px;\n        font-size: 0.9rem;\n    }\n}\n\n@media (max-width: 480px) {\n    .recover_content {\n        padding: 15px;\n    }\n\n    h1 {\n        font-size: 1.5rem;\n    }\n\n    p {\n        font-size: 10px;\n        margin-bottom: 10px;\n    }\n\n    .download_btn {\n        padding: 6px 12px;\n        font-size: 0.8rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
